<template>
  <div
    class="
      lightshadow
      rounded-lg
      mx-3
      flex flex-row
      cateofbrandplace
      overflow-y-auto
    "
  >
    <Sidebar
      v-model="activeKey"
      class="catelistinbrandplace text-center"
      style="background-color: #f6f6f6"
    >
      <SidebarItem
        style="padding-top: 0.75rem; padding-bottom: 0.75rem"
        class="border-b"
        v-for="item in cateList"
        :key="item.signBrandCateId"
        :title="item.cateName"
      />
    </Sidebar>
    <div v-if="cateList.length" class="p-3">
      <div class="text-xxs mb-3">{{ cateList[activeKey]["cateName"] }}</div>
      <List
        class="flex flex-row flex-wrap justify-start"
        finished-text="没有更多了"
      >
        <div
          v-for="item2 in cateList[activeKey]['childCates']"
          :key="item2.signBrandCateId"
          class="mx-1 mb-3 p-3 rounded-lg"
          style="background: #f6f6f6"
          @click="
            $router.push({
              name: 'CateGoods',
              query: {
                signBrandCateId: item2.signBrandCateId,
                cateName: item2.cateName,
                partId: $route.params.partId,
                actId: $route.query.actId,
                signBrandId: $route.query.signBrandId,
              },
            })
          "
        >
          <!-- <div style="height: 74px; width: 74px">
            <img
              class="h-full w-full"
              src="https://img01.yzcdn.cn/vant/cat.jpeg"
              alt=""
            />
          </div> -->
          <div class="text-xxs">{{ item2.cateName }}</div>
        </div>
      </List>
    </div>
  </div>
</template>

<script>
import { Sidebar, SidebarItem, List } from "vant";
import { getBrandCate } from "../webApi";
export default {
  components: { Sidebar, SidebarItem, List },
  created() {
    getBrandCate(this.$route.query.signBrandId).then(({ data }) => {
      this.cateList = data.signBrandCates;
    });
  },
  data() {
    return {
      activeKey: 0,

      cateList: [],
    };
  },
};
</script>

<style lang='less'>
.cateofbrandplace .van-sidebar {
  width: 8rem;
}
.catelistinbrandplace {
  .van-sidebar-item {
    padding-left: 0;
    padding-right: 0;
  }

  .van-sidebar-item__text {
    font-size: 0.625rem;
  }

  .van-sidebar-item--select::before {
    display: none;
  }
}
</style>